export const OPERATOR_TYPES_1 = [
  { value: 'equal_to' },
  { value: 'not_equal_to' },
];

export const OPERATOR_TYPES_2 = [
  { value: 'equal_to' },
  { value: 'not_equal_to' },
  { value: 'contains' },
  { value: 'does_not_contain' },
];

export const OPERATOR_TYPES_3 = [
  { value: 'equal_to' },
  { value: 'not_equal_to' },
  { value: 'is_present' },
  { value: 'is_not_present' },
];

export const OPERATOR_TYPES_4 = [
  { value: 'equal_to' },
  { value: 'not_equal_to' },
  { value: 'is_present' },
  { value: 'is_not_present' },
  { value: 'is_greater_than' },
  { value: 'is_less_than' },
];

export const OPERATOR_TYPES_5 = [
  { value: 'is_greater_than' },
  { value: 'is_less_than' },
  { value: 'days_before' },
];

export const OPERATOR_TYPES_6 = [
  { value: 'equal_to' },
  { value: 'not_equal_to' },
  { value: 'contains' },
  { value: 'does_not_contain' },
  { value: 'starts_with' },
];
